module.exports = __webpack_public_path__ + "static/media/icon-document.6c809fd0.svg";